import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import rCoin from "../assets/images/shell.png";
import useTranslation from "../hooks/useTranslation";

const HostSettlement = () => {
  const { hostHistory } = useSelector((state) => state.history);
  const [data, setData] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    setData(hostHistory);
  }, [hostHistory]);

  return (
    <div style={{ padding: "16px", maxWidth: "600px", margin: "0 auto" }}>
      {data?.length > 0 ? (
        data.map((data, index) => (
          <div key={index} className="host-list-card">
            {/* Period Row */}
            <div className="host-list-row">
              <span className="host-list-label">
                <span className="host-list-icon">
                  <i className="far fa-calendar-alt" />
                </span>
                {t("period")}
              </span>
              <span className="host-list-value">
                {data?.startDate} TO {data?.endDate}
              </span>
            </div>

            {/* Total Coin Row */}
            <div className="host-list-row">
              <span className="host-list-label">
                <span className="host-list-icon">
                  <i className="fas fa-coins" />
                </span>
                {t("total_coin")}
              </span>
              <span className="host-list-value">{data?.amount || 0}</span>
            </div>

            {/* Payment Date Row */}
            <div className="host-list-row">
              <span className="host-list-label">
                <span className="host-list-icon">
                  <i className="far fa-calendar-check" />
                </span>
                {t("payment_date")}
              </span>
              <span className="host-list-value">
                {data?.statusOfTransaction === 1
                  ? t("pending")
                  : data?.payoutDate || t("na")}
              </span>
            </div>

            {/* Amount Row */}
            <div className="host-list-row">
              <span className="host-list-label">
                <span className="host-list-icon">
                  <i className="fas fa-coins" />
                </span>
                {t("amount")}
              </span>
              <span className="host-list-value">
                <img src={rCoin} alt="R Coin" height={18} width={20} />
                {data?.dollar ? data?.dollar : 0}
              </span>
            </div>
          </div>
        ))
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "rgba(255,255,255,0.55)",
            fontSize: "16px",
            background: "transparent",
            borderRadius: "12px",
          }}
        >
          {t("no_data_found")}
        </div>
      )}
    </div>
  );
};

export default HostSettlement;
